module.exports = __webpack_public_path__ + "root-c2082cbd/e83c861f2deebb2a93c2b3e165a3e7b4.woff";